import { useMemberDetails } from "@root/hooks/useMemberDetails";
import React, { createContext, useContext } from "react";

const defaultState: any = {};

const MemberDetailsContext = createContext<any>(defaultState);

export const MemberDetailsContextProvider: React.FC<
  MemberDetailsProviderProps
> = ({ children }) => {
  const data = useMemberDetails();
  return (
    <MemberDetailsContext.Provider value={data}>
      {children}
    </MemberDetailsContext.Provider>
  );
};

export const useMemberDetailsContext = () => {
  return useContext(MemberDetailsContext);
};
